import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getRouterLink, ROUTE_PATH } from '../types/route-path.enum';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
	ROUTE_PATH = ROUTE_PATH;
	getRouterLink = getRouterLink;
	navbarCollapsed = true;

	showBannerOnly$ = new BehaviorSubject(true);
	@Input('showBannerOnly')
	set _showBannerOnly(showBannerOnly: boolean) {
		this.showBannerOnly$.next(showBannerOnly);
	}
}
